export const INFO_CONTENT: any = {
  landCoverMask: {
    title: "Land Cover Mask",
    description:
      "Certain land-cover classes such as tree cover, built-up areas, permanent water bodies, snow/ice, and moss/lichen are not suitable for payout analysis. These areas are removed by applying a land-use mask to the precipitation, soil-moisture, and vegetation datasets.",
  },
  detrendedData: {
    title: "Detrended data",
    description:
      "Detrended data (only available for Tier 1 countries at this moment) accounts for long-term changes in climate and land use, ensuring that drought signals reflect genuine short-term stress rather than gradual environmental change",
  },
  season1: {
    title: "Season 1",
    description:
      "Season 1 is the default season you start configuring. Add season 2 to enable a second season",
  },
  season2: {
    title: "Season 2",
    description: "Season 2 is a secondary user added season. This allows ",
  },
  climate: {
    title: "Climate data",
    description:
      "Climate and vegetation datasets are used to compute the Drought Indices. The data can be visualised on the map (right) and as time series (after a region is selected on the map).​​",
  },
  Precipitation: {
    title: "Precipitation",
    description:
      "The CHIRPS rainfall datasets combines satellite data and weather stations. This dashboard relies on a precipitation product that merges the CHIRPS final and preliminary ('prelim') product. All data were resampled to 10 daily time steps and averaged over each geographical unit.​​",
  },
  "Soil Moisture": {
    title: "Soil moisture",
    description:
      "Root-zone soil moisture is represented by the Copernicus Soil Water Index (SWI). Data is available at 10 daily time step and averaged over each geographical unit.​​",
  },
  Vegetation: {
    title: "Vegetation",
    description:
      "The vegetation health dataset (NDVI) is derived from Sentinel 3 NDVI300 data (from 2020 onwards), calibrated and harmonized with the historical MODIS NDVI record at consistent 10 day intervals.",
  },
  "Hybrid Index": {
    title: "Hybrid Index",
    description:
      "Add a hybrid index consisting of two parameters with a percentage of weight. The total sum of the parameters must be 100%.",
  },
  droughtIndices: {
    title: "Drought indices",
    description:
      "We rely on the standardized anomalies (Z-scores) for all climate and vegetation variables.​ This index indicates how much a given value differs from the standard deviation. The anomaly is computed for the user-defined ‘critical window’ from climate and vegetation data, averaged over the geographical unit.​",
  },
  "Precipitation Anomaly": {
    title: "Precipitation anomaly",
    description:
      "We rely on the standardized anomalies (Z-scores) for all climate and vegetation variables.​ This index indicates how much a given value differs from the standard deviation. The anomaly is computed for the user-defined ‘critical window’ from climate and vegetation data, averaged over the geographical unit.​",
  },
  "Soil Moisture Anomaly": {
    title: "Soil moisture anomaly",
    description:
      "We rely on the standardized anomalies (Z-scores) for all climate and vegetation variables.​ This index indicates how much a given value differs from the standard deviation. The anomaly is computed for the user-defined ‘critical window’ from climate and vegetation data, averaged over the geographical unit.​",
  },
  "Vegetation Anomaly": {
    title: "Vegetation anomaly",
    description:
      "We rely on the standardized anomalies (Z-scores) for all climate and vegetation variables.​ This index indicates how much a given value differs from the standard deviation. The anomaly is computed for the user-defined ‘critical window’ from climate and vegetation data, averaged over the geographical unit.​",
  },
  droughtEvents: {
    title: "Drought events",
    description:
      "We use datasets to represent drought impacts. These datasets can on the time series plots be overlaid with climate data and drought indices.",
  },
  droughtEventsEMDAT: {
    title: "Drought events from EM-DAT",
    description:
      "This dataset corresponds to drought statistics from the International Disasters Database available at the level the Admin 2 level.",
  },
  IPCScore: {
    title: "IPC Score",
    description:
      "Drought statistics from the Integrated Food Security Phase Classification (IPC) scale for Acute Food Insecurity. IPC scores are generated at the level of FEWS NET livelihood zones (higher resolution than Admin 2), but for each area, we use the maximum, annual IPC value for the chosen Admin level.​",
  },
  typeOfComparison: {
    title: "Type of comparison",
    description: (
      <span>
        The payout can be computed and compared for different drought indices or
        different geographical units.​
        <br />
        Depending on the selection, the graph below will show simulated
        historical payouts.
      </span>
    ),
  },
  compareDiffrentDroughtIndices: {
    title: "Compare different drought indices",
    description:
      "You can select multiple drought indices to compare historical payouts for the chosen geographical unit.",
  },
  compareDiffrentGeographicalUnits: {
    title: "Compare different geographical units",
    description:
      "You can select multiple geographical units (up to 3) and one drought index to compare simulated historical payouts.​",
  },
  payoutParameters: {
    title: "Payout parameters",
    description:
      "You can define the parameters used for computing the payout. ​The trigger and Exit levels will be used to determine the conditions when the payout starts/maximum payout is reached. The Sum insured is given in USD, while the other parameters (Deductible, Minimum payout and Maximum payout) are given in percentage of Sum insured.",
  },
};
